let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("HWT6W")).then(() => parcelRequire('2IJwO'));